import { render, staticRenderFns } from "./add-account.component.vue?vue&type=template&id=83aa952a&scoped=true"
import script from "./add-account.component.vue?vue&type=script&lang=js"
export * from "./add-account.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83aa952a",
  null
  
)

export default component.exports